import classNames from 'classnames';
import * as React from 'react';
import { useProductCardContext } from '../ProductCardContext';
import './ActionButtons.scss';

interface ActionButtonsProps {
    bemModifier?: string;
    buttons?: React.ReactElement[];
    favoriteButton?: React.ReactElement;
    hasToShowFavoriteButtonLast?: boolean;
}

function ActionButtons({
    bemModifier,
    favoriteButton,
    buttons,
    hasToShowFavoriteButtonLast = false,
}: ActionButtonsProps) {
    const {
        orientation: cardOrientation,
        actionButtonsPosition,
        activeVariantId,
    } = useProductCardContext();

    return (
        <div className={classNames(
            'palette-product-card-action-buttons',
            `palette-product-card-action-buttons--${actionButtonsPosition}`,
            `palette-product-card-action-buttons--${cardOrientation}`,
            {
                [`palette-product-card-action-buttons--${bemModifier}`]: bemModifier,
            },
        )}
        >
            {!hasToShowFavoriteButtonLast
                ? (
                    <>
                        {favoriteButton && (
                            React.cloneElement(favoriteButton, {
                                className: 'palette-product-card-action-buttons__button',
                                variantId: activeVariantId,
                            })
                        )}
                        {
                            buttons && !!buttons.length && buttons.map(button => (
                                React.cloneElement(button, {
                                    className: 'palette-product-card-action-buttons__button',
                                })
                            ))
                        }
                    </>
                ) : (
                    <>
                        {
                            buttons && !!buttons.length && buttons.map(button => (
                                React.cloneElement(button, {
                                    className: 'palette-product-card-action-buttons__button',
                                })
                            ))
                        }
                        {favoriteButton && (
                            React.cloneElement(favoriteButton, {
                                className: 'palette-product-card-action-buttons__button',
                                variantId: activeVariantId,
                            })
                        )}
                    </>
                )}
        </div>
    );
}

export default ActionButtons;
